if (process.env.NODE_ENV === 'production') {
  module.exports = require('./store.prod.config');
} else {
  module.exports = require('./store.dev.config');
}
